import { http } from "@/http/http.js";
export default {
  //
  pipeGeomInfo2(params) {
    return http.post("/web/gis/pipeGeomInfo2", params);
  },

  pipeInfoByMultipolygon(params) {
    return http.post("/web/gis/pipeInfoByMultipolygon", params);
  },
};
